export const API = 'https://admin.od-do.org';
